// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  // $FlowFixMe
  const OrdersWorker = require('worker-loader?name=[hash].orders.wrkr.js!./worker.js')
  worker = new OrdersWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
